import { Sprite } from 'pixi.js';
import { createBitmapText, scaleToFit } from '../../Utils/Utils';

/**
 * display group with coins icon and text for amount used throughout UI classes
 * @params width - width for group
 * @params height - height for group
 */
export class PlayerCoins extends Sprite {
    private coinTxt: PIXI.extras.BitmapText;

    constructor(width: number, height: number, startCoins: number, showBg: boolean = true) {
        super();
        const bg = new Sprite(PIXI.utils.TextureCache['commonui/wallet-bg']);
        bg.anchor.set(0.5, 0.5);
        bg.scale.set(scaleToFit(bg.width, bg.height, width, height));

        const txt = createBitmapText(
            '0',
            new PIXI.Rectangle(0, bg.height * 0.1, bg.width * 0.5, bg.height * 0.4),
            'riffic'
        );
        txt.anchor = 0.5;

        if (showBg) {
            this.addChild(bg);
        } else {
            bg.destroy();
        }
        this.addChild(txt);
        this.coinTxt = txt;

        this.updatedCoinTxt(startCoins);
    }

    public updatedCoinTxt(amt: number) {
        this.coinTxt.text = amt.toString(10);
    }
}
